module.exports = __webpack_public_path__ + "static/media/materialIcons.v48.0509ab09.woff2";